export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13273.d8ae5a57.jpg";